module.exports = "https://health.dajiuxing.com.cn/img/assets/rightsDetails/Daoan/headbackground.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FrightsDetails%2FDaoan%2Fheadbackground.png
// module id = R3Ra
// module chunks = 93